/* eslint-disable no-shadow */
import { withStyles } from "@material-ui/core";
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import React, { useEffect } from "react";
import styles from "./styles";
import { routes } from "../../routes";
import Header from "../../components/Header";
import Footer from "../../components/Footer";
import { connect } from "react-redux";
import { compose, bindActionCreators } from "redux";
import * as generalActions from "../../actions/general";
import ProjectPage from "../ProjectPage";
import NewsPage from "../NewsPage";
import NotFoundPage from "../NotFoundPage";
import NewsDetail from "../NewsDetail";

import SharedDetail from "./../../containers/SharedDetail";

function App(props) {
  const { classes, generalActionCreators, projectCate, newsCate, displaySearch, generalContent } = props;
  // -----------------step 4-----------
  const { fetchProjectCate, fetchNewsCate, setDisplaySearchAction, fetchGeneralContent, setKeySearchAction} = generalActionCreators;
  const categoryChild = [...projectCate, ...newsCate];

  useEffect(() => {
    fetchProjectCate();
    fetchNewsCate();
    fetchGeneralContent();
  }, [fetchProjectCate, fetchNewsCate, fetchGeneralContent]);
  
  const mapCate = () => {
    let result = [];

    if (categoryChild.length > 0) {
      result = categoryChild.map(item => {
        return (
          <Route
            key={
              item.cateParent === "project"
                ? `project-${item.id}`
                : `news-${item.id}`
            }
            path={
              item.cateParent === "project"
                ? `/du-an/${item.alias}`
                : `/tin-tuc/${item.alias}`
            }
            exact
            component={
              item.cateParent === "project"
                ? ({ match, history }) => (
                    <ProjectPage item={item} match={match} history={history} />
                  )
                : ({ match, history }) => (
                    <NewsPage item={item} match={match} history={history} />
                  )
            }
          />
        );
      });
    }

    return result;
  };

  const showContentMenus = routes => {
    let result = null;

    if (routes.length > 0) {
      result = routes.map(route => {
        return (
          <Route
            key={route.id}
            path={route.path}
            exact={route.exact}
            component={route.main}
          />
        );
      });
    }

    return result;
  };

  return (
    <Router>
      <Header categoryChild={categoryChild} setDisplaySearchAction={setDisplaySearchAction} displayShowSearch={displaySearch} setKeySearchAction={setKeySearchAction} />
      <div className={classes.article}>
        <Switch>
          {showContentMenus(routes)}
          {mapCate()}
          <Route
            key="news-detail"
            path="/tin-tuc/chi-tiet/:id"
            exact={false}
            component={({ match, history }) => (
              <NewsDetail match={match} history={history} />
            )}
          />
          <Route
            key="shared-detail"
            path="/chia-se/chi-tiet/:alias"
            exact={false}
            component={( {match, history}) => (
              <SharedDetail match={match} history={history}/>
            )}
          />
          <Route
            key="not-found"
            path=""
            exact={false}
            component={() => <NotFoundPage />}
          />
        </Switch>
      </div>
      <Footer generalContent={generalContent}/>
    </Router>
  );
}

const mapStateToProps = state => ({
  projectCate: state.general.projectCate,
  newsCate: state.general.newsCate,
  displaySearch: state.general.displaySearch,
  generalContent: state.general.generalContent
});
// ----------step 3----------------------------------
const mapDispatchToProps = dispatch => ({
  generalActionCreators: bindActionCreators(generalActions, dispatch)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withStyles(styles), withConnect)(App);
